/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';
import { EXAMLE, INIT } from './init';
import { useEffect } from 'react';
import { checkValidForm } from './Step1';
import { POLICY_NAME } from '../../POLICY';

const Step2 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep2(true);
            })
            .catch(() => props.setStep2(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cctvIntroductionLawfulBasis) {
            onValuesChange(
                null,
                props.previewData?.cctvIntroductionLawfulBasis
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cctvIntroductionTitleTh',
            'cctvIntroductionTitleEn',
            'cctvLawfulBasisTitleTh',
            'cctvLawfulBasisTitleEn',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep2(check);
    };

    const cctvCompanyNameTh =
        props.cctvPolicy?.cctvCompanyNameTh || '[company_name]';
    const cctvCompanyNameEn =
        props.cctvPolicy?.cctvCompanyNameEn || '[company_name]';

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Introduction and Lawful Basis', {
                    ns: POLICY_NAME.CCTV_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cctvIntroductionLawfulBasis"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cctvIntroductionLawfulBasis}
            >
                {/* Introduction */}
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Introduction')}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvIntroductionTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvIntroductionContentTh.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameTh
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvIntroductionContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvIntroductionTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvIntroductionContentEn.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameEn
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvIntroductionContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Divider />
                {/* Lawful Basis personal data */}
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t('Lawful Basis personal data', {
                            ns: POLICY_NAME.CCTV_POLICY,
                        })}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvLawfulBasisTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox code={EXAMLE.cctvLawfulBasisContentTh} />
                    <Form.Item
                        className="mt-4"
                        name="cctvLawfulBasisContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvLawfulBasisTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox code={EXAMLE.cctvLawfulBasisContentEn} />
                    <Form.Item
                        className="mt-4"
                        name="cctvLawfulBasisContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                </div>
                <Form.Item
                    hidden
                    name="cctvIntroductionLawfulBasisId"
                ></Form.Item>
                <Form.Item hidden name="cctvIntroductionIsDisplay"></Form.Item>
                <Form.Item hidden name="cctvLawfulBasisIsDisplay"></Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                            className="ml-4"
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step2;
